import React from 'react'
import Navbar from '../components/Navbar';
import HeroImg from "../components/HeroImg";
import Footer from "../components/Footer";
import Work from '../components/Work';
import WhatsAppButton from '../components/WhatsAppButton';

const Home = () => {
  return (
    <div>
        <Navbar/>
        <HeroImg/>
        <Work/>
        <WhatsAppButton />
        <Footer/>
    </div>
  )
}

export default Home